import { DropDownList } from "@progress/kendo-react-dropdowns";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export function bindI18nEvents() {
    i18n.on("loaded", () => {
        i18n.loadNamespaces("common/attribute_type_dropdown");
        updateTranslations();
    })
    i18n.on("languageChanged", () => {
        i18n.loadNamespaces("common/attribute_type_dropdown");
        updateTranslations();
    })
}

function updateTranslations() {
    const fdfd = recommendationAttributeType;
    recommendationAttributeType.forEach((item) => {
        item.text = i18n.t(item.value, { ns: "common/attribute_type_dropdown"});
    })
}

export const recommendationAttributeType = [
    {
        "text": "Text",
        "value": "String"
    },
    {
        "text": "Number - Integer",
        "value": "Number_Integer"
    },
    {
        "text": "Number - Decimal",
        "value": "Number_Decimal"
    },
    {
        "text": "Dropdown",
        "value": "Picklist String"
    },
    {
        "text": "Date Time - Date",
        "value": "DateTime_Date"
    },
    {
        "text": "Date Time - DateTime",
        "value": "DateTime"
    },
    {
        "text": "Date Time - Time",
        "value": "DateTime_Time"
    },
    {
        "text": "User Identity",
        "value": "User Identity"
    },
    {
        "text": "Email",
        "value": "Email"
    },
    {
        "text": "Link",
        "value": "URL"
    },
    {
        "text": "Rich Content",
        "value": "Html"
    },
    {
        "text": "True/False",
        "value": "Boolean"
    },
    {
        "text": "Long Text",
        "value": "Multiline Text"
    },
    {
        "text": "Tags",
        "value": "Tags"
    },
    {
        "text": "State",
        "value": "State Field"
    }
];

function AttributeTypeDropdown({ value, onChange }) {

    const { t } = useTranslation("common/attribute_type_dropdown", {
        useSuspense: false
    });

    const [data, setData] = useState([]);

    useEffect(() => {
        const data = recommendationAttributeType.map((item) => {
            return {
                text: t(item.value),
                value: item.value
            }
        });
        setData(data);
    }, [])

    const valueObject = data.find((item) => item.value === value);

    return (
        <DropDownList
            data={data}
            onChange={onChange}
            textField="text"
            value={valueObject}
        />
    )
}

export default AttributeTypeDropdown;